<script setup>
import { useUserAuthStore } from "@/composables/store/user/useAuthStore";
import { useSuccessStore } from "@/composables/store/useSuccessStore";
import { useGenerateImageVariant } from "@core/composable/useGenerateImageVariant";
import Logo from '@images/illustrations/sphiere_logo.png';
import authV2ForgotPasswordIllustrationDark from "@images/pages/auth-v2-forgot-password-illustration-dark.png";
import authV2ForgotPasswordIllustrationLight from "@images/pages/auth-v2-forgot-password-illustration-light.png";
import authV2MaskDark from "@images/pages/misc-mask-dark.png";
import authV2MaskLight from "@images/pages/misc-mask-light.png";

const authStore = useUserAuthStore();
const successStore = useSuccessStore();
const email = ref("");
const refVForm = ref(null);
const authThemeImg = useGenerateImageVariant(
  authV2ForgotPasswordIllustrationLight,
  authV2ForgotPasswordIllustrationDark
);
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark);

definePage({
  meta: {
    layout: "blank",
    unauthenticatedOnly: true,
  },
});

const onSubmit = async () => {
  try {
    const isValid = await refVForm.value.validate()
    if (!isValid.valid) return
    await authStore.forgetPassword(email.value)
    successStore.setSuccessMessage("Reset link sent successfully")
  } catch (error) {
    console.error("Password reset error:", error)
    // Handle error (show message to user, etc.)
  }
}
</script>

<template>
  <VRow class="auth-wrapper bg-surface" no-gutters>
    <VCol md="7" class="d-none d-md-flex" style="
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        margin: 0;
        background:#232323;
        block-size: 100vh;
        color: white;
      ">

      <div class="d-flex align-center justify-center w-100 h-100">
        <VImg :src="Logo" style=" max-block-size: 200px; max-inline-size: 300px;" />
      </div>


    </VCol>

    <VCol cols="12" md="5" class="auth-card-v2 d-flex align-center justify-center">
      <VCard flat :max-width="500" class="mt-12 mt-sm-0 pa-4">
        <VCardText>
          <!-- <VNodeRenderer :nodes="themeConfig.app.logo" class="mb-6" /> -->
          <h4 class="text-h4 mb-1">
            FORGOT PASSWORD?
          </h4>
          <p class="mb-0">
            Password Recovery
          </p>
        </VCardText>

        <VCardText>
          <VForm ref="refVForm" @submit.prevent="onSubmit">
            <VRow>
              <!-- email -->
              <VCol cols="12">
                <AppTextField v-model="email" autofocus label="Email" placeholder="johndoe@email.com" type="email"
                  :rules="[requiredValidator, emailValidator]" />
              </VCol>

              <!-- Reset link -->
              <VCol cols="12">
                <VBtn block type="submit" color="primary">
                  Send Reset Link
                </VBtn>
              </VCol>

              <!-- back to login -->
              <VCol cols="12">
                <RouterLink class="d-flex align-center justify-center" :to="{ name: 'user-authentication-login' }">
                  <VIcon icon="tabler-chevron-left" class="flip-in-rtl" />
                  <span>Back to login</span>
                </RouterLink>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
